export default function Paper() {
	return {
		MuiPaper: {
			styleOverrides: {
				root: ({ theme, ownerState }) => ({
					...(theme.palette.mode === 'dark' && {
						backgroundColor: theme.palette.paperBackgrounds[ownerState.elevation],
						border: `1px solid ${theme.palette.divider}`,
					}),
				}),
			},
		},
	}
}
